<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-download"></i>
        WSFinder(Webシェル) Dashboard
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Dashboard</a>
        </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> WSFinder(Webshell) Dashboard
      </template> -->
        <b-row>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-primary">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="module_check_1" :value="info && info.module ? info.module.alive + info.module.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                  <sup style="font-size: 20px"> インストール済み</sup></strong></h1>
                <hr>
                <h6>最近の情報</h6>
                <h4>有効 :
                  <animated-number ref="module_check_2" :value="info && info.module && info.module.alive > 0 ? info.module.alive : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>削除 :
                  <animated-number ref="module_check_3" :value="info && info.module && info.module.deleted > 0 ? info.module.deleted : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>トータル :
                  <animated-number ref="module_check_4" :value="info && info.module && info.module.deleted > 0 ? info.module.deleted + info.module.alive : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-success">
              <b-card-body class="pb-0" >
                <h1><strong>
                  <animated-number ref="scan_check_1" :value="info && info.day && info.day.scan_count > 0 ? info.day.scan_count : 0" :formatValue="value_comma" :duration="1500"/>
                  <sup style="font-size: 20px"> チェック済み</sup></strong></h1>
                <hr>
                <h6>最近の情報</h6>
                <h4>今日 :
                  <animated-number ref="scan_check_2" :value="info && info.day && info.day.scan_count > 0 ? info.day.scan_count : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>直近7日間 :
                  <animated-number ref="scan_check_3" :value="info && info.week && info.week.scan_count > 0 ? info.week.scan_count : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>今月 :
                  <animated-number ref="scan_check_4" :value="info && info.month && info.month.scan_count > 0 ? info.month.scan_count : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-danger">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="detect_check_1" :value="info && info.day && info.day.detect_count > 0 ? info.day.detect_count : 0" :formatValue="value_comma" :duration="1500"/>
                <sup style="font-size: 20px"> 検出済み</sup></strong></h1>
                <hr>
                <h6>最近の情報</h6>
                <h4>今日 :
                  <animated-number ref="detect_check_2" :value="info && info.day && info.day.detect_count > 0 ? info.day.detect_count : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>直近7日間 :
                  <animated-number ref="detect_check_3" :value="info && info.week && info.week.detect_count > 0 ? info.week.detect_count : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>今月 :
                  <animated-number ref="detect_check_4" :value="info && info.month && info.month.detect_count > 0 ? info.month.detect_count : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="3">
            <b-card no-body class="bg-warning">
              <b-card-body class="pb-0">
                <h1><strong>
                  <animated-number ref="isolation_check_1" :value="info && info.day && info.day.isolation_count > 0 ? info.day.isolation_count : 0" :formatValue="value_comma" :duration="1500"/>
                <sup style="font-size: 20px"> 隔離</sup></strong></h1>
                <hr>
                <h6>最近の情報</h6>
                <h4>今日 :
                  <animated-number ref="isolation_check_2" :value="info && info.day && info.day.isolation_count > 0 ? info.day.isolation_count : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>直近7日間 :
                  <animated-number ref="isolation_check_3" :value="info && info.week && info.week.isolation_count > 0 ? info.week.isolation_count : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
                <h4>今月 :
                  <animated-number ref="isolation_check_4" :value="info && info.month && info.month.isolation_count > 0 ? info.month.isolation_count : 0" :formatValue="value_comma" :duration="1500"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    <b-card ref="_ms">
      <b-row>
        <b-col class="title">
          エージェントの状況 (最大表示 100)
          <b-button class="float-right btn-addition" size="m" variant='success' to="/downloads/">ダウンロード</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row class="text-center" v-if="agents.length > 0">
        <b-col md="3" sm="3" xl="3" v-for="(item, index) in agents" :key="index" :ref="`_agent_${index}`">
          <b-card @click="detail(item)" :style="{ cursor: 'pointer'}">
            <b-badge variant="success" v-if="!item.ms == 0 ">オンライン</b-badge>
            <b-badge v-else>オフライン</b-badge>
            <p class="ml-2 font-weight-bold">{{item.name || '-'}}</p>
            <hr>
            <h6>{{item.ip_addr}}<br></h6>
            <b-badge variant="info">チェック済み : {{item.total_scan}}</b-badge>
            <br>
            <b-badge v-if="item.total_detect" variant="danger">検出 : {{item.total_detect}}</b-badge>
            <!-- <i v-if="item.scanning" class="fa fa-refresh fa-spin"></i> -->
            <hr>
            <p>
              <b-spinner variant="warning" v-if="item && item.scanning" small type="grow"></b-spinner>
              <span :class="`font-weight-bold ml-1 ${item.scanning ? 'text-warning' : ''}`">
                {{item.scanning ? '進行中' : '待機中'}}
              </span>
            </p>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="this.count == 0" style="text-align:center;">
        <b-col sm="6" lg="12">
          <b-card no-body class="bg-success">
            <b-card-body class="pb-20">
              <h3 class="mb-0">エージェントはインストールされていません</h3>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <!-- <router-view ></router-view> -->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
